import { render, staticRenderFns } from "./CurrentActionDetailsDialog.vue?vue&type=template&id=a0f65b90&scoped=true"
import script from "./CurrentActionDetailsDialog.vue?vue&type=script&lang=js"
export * from "./CurrentActionDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f65b90",
  null
  
)

export default component.exports